import { render } from "./ZNBJedit.vue?vue&type=template&id=4bbd4758&scoped=true"
import script from "./ZNBJedit.vue?vue&type=script&lang=js"
export * from "./ZNBJedit.vue?vue&type=script&lang=js"

import "./ZNBJedit.vue?vue&type=style&index=0&id=4bbd4758&lang=scss&scoped=true"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bbd4758"]])

export default __exports__